<div class="m-form-field">
  <div class="a-search-input" [class.--close-visible]="value$ | async">
    @if (label){
    <label [for]="id"> {{ label }} @if(isRequired$ | async){ * } </label>
    }

    <input
      [id]="id"
      [formControl]="control"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [disabledControl]="isDisabled$ | async"
      [boschUiInputAutofocus]="autofocus"
      type="search"
    />

    <button
      type="button"
      class="a-search-input__icon-close tw-bg-bosch-gray-85 hover:tw-bg-bosch-gray-75"
      (click)="onClear()"
    >
      <bosch-ui-icon [name]="iconNames.CloseSmall"></bosch-ui-icon>
    </button>
    <button type="submit" class="a-search-input__icon-search" aria-label="Search" (click)="onSearch()">
      <bosch-ui-icon [name]="iconNames.Search"></bosch-ui-icon>
    </button>
  </div>
  @if (!errorRef && (error$ | async); as error) {
  <bosch-ui-validation-error [error]="'common.validation.error.' + error | translate"></bosch-ui-validation-error>
  } @if (errorRef) {
  <ng-content></ng-content>
  }
</div>
